import Form from "../components/Form";
import React, { useState, useEffect, useRef } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Checkbox } from "@mui/material";
import { useLocation } from "react-router-dom";
import axios from "axios";
import NavbarCharity from "../layout/NavbarCharity";
import { Title } from "../components/charity/title";
import FooterCharity from "../layout/FooterCharity";

function Charity4() {
  const location = useLocation();
  const [articleContent, setArticleContent] = useState({});
  const [payment, setPayment] = useState("bankTransfer");
  const [donationAmount, setDonationAmount] = useState("");
  const [donorName, setDonorName] = useState("");
  const [donorPhone, setDonorPhone] = useState("");
  const [receiptAddress, setReceiptAddress] = useState("");
  const [receiptName, setReceiptName] = useState("");
  const [receiptPhone, setReceiptPhone] = useState("");
  const [receiptRequested, setReceiptRequested] = useState(false);
  const [activityListContent, setActivityListContent] = useState([]);
  const [pagePath, SetPagePath] = useState("");
  const [charityID, setCharityID] = useState(0);
  const [charityActivityID, setCharityActivityID] = useState(0);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [orderNo, setOrderNo] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    let id = searchParams.get("id");
    setCharityID(id*1);
    SetPagePath(id);

    let activityID = searchParams.get("activityID");
    setCharityActivityID(activityID);

    // 檢查付款狀態
    const orderNo = searchParams.get("order_no");
    const status = searchParams.get("status");
    const errmsg = searchParams.get("errmsg");
    
    console.log("URL Parameters:", {
      orderNo,
      status,
      errmsg,
      fullUrl: window.location.href
    });
    
    if (status === "success" && orderNo) {
      console.log("Showing success message");
      setOrderNo(orderNo);
      setShowSuccessMessage(true);
      // 5秒後自動隱藏成功訊息
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 5000);
    } else if (status === "fail" && errmsg) {
      setShowErrorMessage(true);
      setErrorMessage(errmsg);
      // 30秒後自動隱藏錯誤訊息
      setTimeout(() => {
        setShowErrorMessage(false);
      }, 30000);
    }

    axios
      .post("/api/website/getCharity", { id: id * 1 })
      .then((response) => {
        const pageData = response.data.data.data;
        document.title = pageData.title;
        setArticleContent(pageData);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });
  }, [location.search]);

  useEffect(() => {
    if (charityID != 0) {
      axios
        .post("/api/website/getCharityActivityList", { id: charityID })
        .then((response) => {
          setActivityListContent(response.data.data.activityList);
        })
        .catch((error) => {
          console.error("Error fetching article content:", error);
        });
    }
  },[charityID])

  const validateForm = () => {
    if (!donationAmount) {
      alert("請輸入捐款金額");
      return false;
    }
    if (!donorName) {
      alert("請輸入姓名");
      return false;
    }
    if (!donorPhone) {
      alert("請輸入電話");
      return false;
    }

    if (receiptRequested) {
      if (!receiptAddress) {
        alert("請輸入寄送地址");
        return false;
      }
      if (!receiptName) {
        alert("請輸入收件姓名");
        return false;
      }
      if (!receiptPhone) {
        alert("請輸入收件電話");
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    let activityType = "charity";

    if (charityActivityID == "normal") {
      activityType = "normal";
    } else if (charityActivityID == "funeral") {
      activityType = "funeral";
    } else {
      activityType = "activity";
    }

    const donationData = {
      amount: parseInt(donationAmount, 10),
      name: donorName,
      phone: donorPhone,
      activityType: activityType,
      charityID: charityID,
      charityActivityID: charityActivityID * 1,
      needReceipt: receiptRequested,
      receiptInfo: receiptRequested ? {
        address: receiptAddress,
        name: receiptName,
        phone: receiptPhone
      } : null
    };

    let apiUrl = "/api/homepage/donate";

    if (payment === "bankTransfer") {
      apiUrl = "/api/homepage/donate/atm";
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(donationData),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const htmlContent = await response.text();
      handlePaymentSubmit(htmlContent);
    } catch (error) {
      console.error("Error submitting donation:", error);
    }
  };

  const handlePaymentSubmit = (htmlContent) => {
    const paymentWindow = window.open("", "_blank");

    if (paymentWindow) {
      paymentWindow.document.write(htmlContent);

      const form = paymentWindow.document.querySelector("form");
      if (form) {
        form.submit();
      }
    } else {
      alert("無法開新視窗，請檢察瀏覽器設定。");
    }
  };

  return (
    <>
      <NavbarCharity path={pagePath} charityName={articleContent.title} />
      <main className="relative">
        <div 
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#4CAF50',
            color: 'white',
            padding: '50px 100px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 9999,
            display: showSuccessMessage ? 'block' : 'none',
            fontSize: '18px',
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          <p>感謝您的捐款！</p>
          <p>您的捐款標號為：{orderNo}</p>
          <p>您的善心將幫助更多需要幫助的人。</p>
        </div>
        <div 
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#FF4747',
            color: 'white',
            padding: '50px 100px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 9999,
            display: showErrorMessage ? 'block' : 'none',
            fontSize: '16px',
            fontWeight: 'bold',
            textAlign: 'center',
            width: '300px',
            height: '100px',
            lineHeight: '100px',
          }}
        >
          <p>付款失敗，請重新操作</p> 
          <p>{errorMessage}</p>
        </div>
        <section className="h-[250px] m-auto page-title flex items-center justify-center">
          <Title title={"我要捐款"} subTitle={"Charity Donation"} />
        </section>
        <section className="flex gap-10 max-w-7xl table:max-w-4xl mx-auto py-24 table:py-16 mobile:py-10 w-[90%] table:flex-col table:items-center mobile:flex-col mobile:items-center">
          <div className="table:max-w-none table:w-full mobile:w-full">
            <div className=" bg-[#FFF4DA] rounded-xl p-9 sticky top-[120px]">
              <p className="text-3xl font-extrabold mb-7">是的！我願意盡一薄之力！</p>
              <p className="mb-11">感謝有你的善心捐款，讓我們將愛傳播到世界各地！</p>
              <p className="text-xl mb-3">選擇項目</p>
              <select value={charityActivityID} onChange={(e) => setCharityActivityID(e.target.value)}>
                <option value="">請選擇</option>
                {
                  activityListContent.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                  ))
                }
                <option value="normal">一般捐款(不指定用途)</option>
                <option value="funeral">喪葬專戶(不指定個案)</option>
              </select>
              <br />
              <FormControl>
                <label htmlFor="" className="mr-2 text-xl mt-4">
                  捐款方式
                </label>
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={payment}
                  onChange={(e) => setPayment(e.target.value)}
                >
                  <FormControlLabel value="bankTransfer" control={<Radio />} label="銀行轉帳" />
                  <FormControlLabel value="creditCard" control={<Radio />} label="信用卡" />
                </RadioGroup>
              </FormControl>
              <br />
              {payment === "creditCard" && (
                <React.Fragment>
                <p className="text-xl mb-3">選擇金額</p>
                <div className="mb-4">
                  <label htmlFor="" className="mr-2 text-xl">
                    新臺幣
                  </label>
                  <input
                    type="text"
                    className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 h-12 mb-3 w-full"
                    placeholder="其他金額"
                    required
                    value={donationAmount}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setDonationAmount(value);
                    }}
                  />
                  <br />
                  <label htmlFor="" className="mr-2 text-xl">
                    姓名
                  </label>
                  <input
                    type="text"
                    className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 h-12 mb-3 w-full"
                    placeholder="請輸入姓名"
                    required
                    title="請填寫姓名"
                    value={donorName}
                    onChange={(e) => setDonorName(e.target.value)}
                  />
                  <br />
                  <label htmlFor="" className="mr-2 text-xl">
                    電話
                  </label>
                  <input
                    type="text"
                    className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 h-12 w-full"
                    placeholder="請輸入電話"
                    required
                    title="請填寫電話"
                    value={donorPhone}
                    maxLength="10"
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '');
                      setDonorPhone(value);
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={receiptRequested}
                        onChange={(e) => setReceiptRequested(e.target.checked)}
                      />
                    }
                    label="我要收據"
                    className="mt-4"
                  />
                  {receiptRequested && (
                    <div>
                      <label htmlFor="receiptAddress" className="mr-2 text-xl">
                        寄送地址
                      </label>
                      <input
                        type="text"
                        id="receiptAddress"
                        className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[396px] h-12 mb-3"
                        placeholder="請輸入地址"
                        title="請填寫地址"
                        required
                        value={receiptAddress}
                        onChange={(e) => setReceiptAddress(e.target.value)}
                      />
                      <br />
                      <label htmlFor="receiptName" className="mr-2 text-xl">
                        收件姓名
                      </label>
                      <input
                        type="text"
                        id="receiptName"
                        className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[396px] h-12 mb-3"
                        placeholder="請輸入姓名"
                        title="請填寫姓名"
                        required
                        value={receiptName}
                        onChange={(e) => setReceiptName(e.target.value)}
                      />
                      <br />
                      <label htmlFor="receiptPhone" className="mr-2 text-xl">
                        收件電話
                      </label>
                      <input
                        type="text"
                        id="receiptPhone"
                        className="bg-[#FFE8B4] placeholder:text-[#C4B48E] rounded-md py-3 px-4 w-[396px] h-12"
                        placeholder="請輸入電話"
                        pattern="[0-9]{10}"
                        title="請填寫電話"
                        required
                        maxLength="10"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, '');
                          setReceiptPhone(value);
                        }}
                        value={receiptPhone}
                      />
                    </div>
                  )}
                </div>
                </React.Fragment>
              )}
              {
                payment === "bankTransfer" && (
                  <React.Fragment>
                    <div className="mb-2 font-bold">
                      <p>一、元大銀行(中港分行) 銀行代號：806</p>
                      <p>帳號：20952-0000-29468</p>
                      <p>戶名：社團法人中華誠信慈善協會</p>
                    </div>
                    <div className="mb-2 font-bold">
                      <p>二、不丹計畫專戶</p>
                      <p>元大銀行(中科分行) 銀行代號：806-0954</p>
                      <p>帳號：20952-0000-50617</p>
                      <p>戶名：社團法人中華誠信慈善協會</p>
                    </div>
                    <div className="mb-2 font-bold">
                      <p>三、喪葬補助專戶</p>
                      <p>永豐銀行(中科分行) 銀行代號：807</p>
                      <p>帳號：041-018-0000666-6</p>
                      <p>戶名：社團法人中華誠信慈善協會</p>
                    </div>
                  </React.Fragment>
                )
              }
              
              <p className="my-5 text-base leading-relaxed">
                小小貢獻是弱勢朋友一整年的支持，
                邀您捐出一日所得，一次讓全台百萬弱勢族群得到專業照護！
              </p>
              
              {payment === "creditCard" && (
                <button
                  onClick={handleSubmit}
                  className="w-full h-[70px] bg-[#FF4747] rounded-md text-xl text-[#FFF] hover:bg-opacity-80"
                >
                  我要捐款
                </button>
              )}
            </div>
          </div>
          <div className="mx-auto leading-loose text-[#373737] w-full">
            <div className="border-l-8 border-[#FF6B2B] pl-3 mb-14">
              <h2 className="text-5xl text-[#3D3D3D] mb-2">捐款紀錄</h2>
              <h3 className="text-2xl text-[#FF6B2B]">Donation Record</h3>
            </div>
            <div>
              <Form />
            </div>
          </div>
        </section>
      </main>
      <FooterCharity />
    </>
  );
}

export default Charity4;
